import React, { useEffect } from 'react';
import logo from './logo.png';

import './App.css';
var hDivUUIDs = []
function LayerContainer({ children, className }) {
  if (className === undefined) { className = ""; }
  return (
    <div className={"absolute-container "+className}>
      {children}
    </div>
  );
}

function Layer ({children, z, className}) {
  return (
    <div className={`layer ${className || ''}`} style={{zIndex: z}}>
      {children}
    </div>
  );
}

function Divider({type, children, size}) {
  let lsize = ""
  if (!size || size === undefined || size === null) {
    lsize = "1";
  }else{
    lsize = size.toString();
  }
  
  
  if (type ==="h"){
    const uuid = "dividerUUID" + crypto.randomUUID();
    return (
      <div style={{width: '100%', flex: lsize}} id={uuid}>{children}</div>
    );
  } else if (type === "v") {
    const uuid = "dividerUUID" + crypto.randomUUID();
    hDivUUIDs.push(uuid);
    localStorage.setItem("hDivUUIDs", JSON.stringify(hDivUUIDs));
    return (
      <div
        style={{height: '100%', flex: lsize }}
        id={uuid}
        onLoad={(e) => {
          const parent = e.target.parentElement;
          if (parent) {
            parent.style.flexDirection = "column";
          }
        }}
      >
        {children}
      </div>
    );
  } else {
    return (
      <div style={{height: '100%', width: '100%', flex: lsize}}>{children}</div>
    );
  }
}

function Thingy({script,children,z,classNameInherit}) {
  let elems = script.split(";") // 3x,v,2,1s;3x,h,2,3s
  let prevFunction = ({children}) => (<>{children}</>)
  for (let i = 0; i < elems.length; i++) {
    if (elems[i].trim() === "") { continue; }
    let parts = elems[i].split(",") // 3x,v,2,1s // x is count, v/h is type, <number> is order s is size. 
    // 3x,v,2,1s says "make 3 vertical dividers, select the 2nd one, and make it size 1, then return the selected one"
    let count = 0
    let type = ""
    let th = 0
    let size = 1
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i].trim().toLowerCase();
      if (parts[i].endsWith("x")) {
        count = parseInt(parts[i].slice(0, -1))
      } else if (parts[i] === "v" || parts[i] === "h") {
        type = parts[i]
      } else if (parts[i].endsWith("s")) {
        size = parseInt(parts[i].slice(0, -1))
      } else {
        th = parseInt(parts[i])
      }
    }
    if (count <= 0 || th <= 0) { return (<><div>ERROR at script: {script}<br/>at nest index {i}, fragment {parts[i]}.<br/>Parsed:<br/> count: {count} type: {type} th/order: {th} size: {size}<br/>Both count (3x,4x,etc) and th/order (1,2,3) must be specified and positive integers, all others are optional. </div></>)}
    let before = <></>
    for (let j = 1; j < th; j++) {
          before = <>
            {before}
            <Divider type={type} className={classNameInherit}></Divider>
          </>
    }
    let after = <></>
    for (let j = th; j < count; j++) {
          after = <>
            <Divider type={type} className={classNameInherit}></Divider>
            {after}
          </>
    }
    const prev = prevFunction;
    let newFunction = ({children}) => prev({children:(
      <>
        {before}
        <Divider type={type} size={size} className={classNameInherit}> {children}</Divider>
        {after}
      </>)}
    )
    prevFunction = newFunction

  }
  return <Layer z={z} className={classNameInherit}>{prevFunction({children: children})}</Layer>;
}

function ThingyEach({script,children,z,dividerStyles}) {
  let elems = script.split(";") // 16x,h,1;9x,v,1
  
  let gridStructure = [];
  for (let i = 0; i < elems.length; i++) {
    if (elems[i].trim() === "") { continue; }
    let parts = elems[i].split(",");
    let count = 0;
    let type = "";
    
    for (let j = 0; j < parts.length; j++) {
      parts[j] = parts[j].trim().toLowerCase();
      if (parts[j].endsWith("x")) {
        count = parseInt(parts[j].slice(0, -1));
      } else if (parts[j] === "v" || parts[j] === "h") {
        type = parts[j];
      }
    }
    
    if (count > 0 && type) {
      gridStructure.push({ count, type });
    }
  }
  
  function buildGrid(structure, depth = 0) {
    if (depth >= structure.length) {
      return children;
    }
    
    const current = structure[depth];
    const dividers = [];
    
    for (let i = 0; i < current.count; i++) {
      dividers.push(
        <Divider key={i} type={current.type} style={dividerStyles}>
          {buildGrid(structure, depth + 1)}
        </Divider>
      );
    }
    
    return <>{dividers}</>;
  }
  
  return <Layer z={z}>{buildGrid(gridStructure)}</Layer>;
}

// eslint-disable-next-line
function MathEq({func, x1, x2, y1, y2, width, height, strokeWidth, color}) {
  let resolution = 1000;
  let step = (x2 - x1) / resolution;
  let points = [];
  for (let i = 0; i <= resolution; i++) {
    let x = x1 + i * step;
    let y = func(x);
    points.push([x, y]);
  }
  const viewBox = `${x1} ${y1} ${x2 - x1} ${y2 - y1}`;
  return (
    <svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <polyline
        fill="none"
        stroke={color || "black"}
        strokeWidth={strokeWidth || 2}
        points={points.map(p => `${p[0]},${p[1]}`).join(" ")}
      />
    </svg>
  );
}
window.ColorModulo = 0;
function ColorOnHover(){
  let uuid = "colorOnHover" + crypto.randomUUID();
  let coloridx = Math.floor(Math.random()*6)
  let colorer = ()=>{
    let color = ["#e57373", "#64b5f6", "#81c784", "#fff176", "#ba68c8", "#ffb74d"][coloridx];
    let elem = document.getElementById(uuid);
    if (elem) {
      elem.style.transition = "background-color 0s ease"
      elem.style.backgroundColor = color;
      setTimeout(()=>{
        elem.style.transition = "background-color 0.5s ease"; 
        elem.style.backgroundColor = "black";
      }, 100);
    }
  }
  return <div id={uuid} onMouseOver={colorer} style={{width: '100%', height: '100%', backgroundColor: 'black', boxSizing: 'border-box', border: '3px solid black'}}></div>;
}
function ColoredRoundedSquare({color,radius,children,marginLeft,marginRight,pointerEvents}){
  if (marginLeft === undefined) { marginLeft = 'auto'; }
  if (marginRight === undefined) { marginRight = 'auto'; }
  if (pointerEvents === undefined) { pointerEvents = 'none'; }
  return (
    <div
      style={{
        width: 'fit-content',
        height: 'fit-content',
        backgroundColor: color || 'rgba(0,0,0,0.3)',
        borderRadius: radius || '30px',
        marginLeft: marginLeft,
        marginRight: marginRight, pointerEvents: pointerEvents,
      }}
    >
      {children}
    </div>
  );
}
function PageDiv({children,path,className}){

  return <div id={"page-" + path.replace(/\W+/g, '-').toLowerCase()} className={className} style={{display:'none'}}>{children}</div>;
}
function Button({href,children,className,color}){
  if (color === undefined) { color = "#2196f3"; }
  return (
    <a href={href} className={className} style={{ textDecoration: 'none', color: 'inherit' }}>
      <button
        style={{
          padding: '10px 24px',
          borderRadius: '8px',
          border: '2px solid #1976d2',
          backgroundColor: color,
          color: 'white',
          fontWeight: '500',
          fontSize: '1rem',
          cursor: 'pointer',
          transition: 'background 0.2s, box-shadow 0.2s',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          pointerEvents: 'all',
        }}
        onMouseOver={e => e.currentTarget.style.backgroundColor = '#1976d2'}
        onMouseOut={e => e.currentTarget.style.backgroundColor = '#2196f3'}
      >
        {children}
      </button>
    </a>
  );
}

function PageTemplate({children,path}){
  return (
    <PageDiv path={path} className= "app">
      <LayerContainer>
        <Thingy script={"1x,v,1;3x,h,2;2x,h,1"} z={1} className="clickthrough" classNameInherit="clickthrough">
          <ColoredRoundedSquare marginLeft="auto" marginRight="auto" radius="0px">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'left', width: '100%', justifyContent: 'center' }}>
              
              <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', color: 'white', margin: '50px', maxWidth: '1200px', width: '100%' }}>
                 <div style={{ width: '100%' }}>
                  <a href="/" style={{ color: '#64b5f6', textDecoration: 'underline', fontSize: "0.8rem" }}>Return to homepage</a>
                  &nbsp;
                  {children}
                 </div>
              </div>
            </div>
          </ColoredRoundedSquare>
        </Thingy>
        <ThingyEach script={"16x,h,1;9x,v,1"} z={0} dividerStyles={{border: '3px solid black'}}>
          <ColorOnHover></ColorOnHover>
        </ThingyEach>
      </LayerContainer>
    </PageDiv>
    );
  }


//let logosrc = "logo.png"
function App() {
  useEffect(() => {
    var currentURL = window.location.href.substring(1);
    var redirect = sessionStorage.redirect;
    var hash = window.location.hash;
    delete sessionStorage.redirect;
    if (hash && hash !=="/"){
      currentURL = "https://axiom.hackclub.com/"+hash.substring(2)
      console.log("Changed current URL variable because hash was found",hash)
    }
    else if (redirect && redirect !==window.location.href) {
      currentURL=redirect
      console.log("Changed current URL variable because redirect was found")
    }
    
    console.log("Current URL:", currentURL);
    var page = currentURL.split("/").slice(3);
    var pathID = page.join("/").replace(/\W+/g, '-').toLowerCase();
    console.log("Page:", page);
    console.log("Path ID: /", pathID);

    window.currentPage = page;
    window.currentPathID = pathID;
    let pagediv = document.getElementById("page-" + pathID);
    if (pagediv) {
      pagediv.style.display = "block";
    } else {
      let four04div = document.getElementById("page-404");
      if (four04div) {
        four04div.style.display = "block";
      }
    }
    }, []);
  return (
    <>
    <PageDiv path="" className="App">
      
      <LayerContainer className="PC">
        <Thingy script={"3x,v,2;3x,h,2;2x,h,1"} z={1} className="clickthrough" classNameInherit="clickthrough">
          <ColoredRoundedSquare pointerEvents={"none"}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
              <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={logo} alt="Axiom Logo" width="400" style={{ marginLeft: 'auto' }} />
              </div>
              <div style={{ flex: 1, display: 'flex', justifyContent: 'left', alignItems: 'left', color: 'white', margin: '50px' }}>
                 <div>
                  {/* c75d53ff-5b68-455e-ab8d-abc94dda6548 */}
                 <h1>Make a math/science related app,<br></br> get rewards!</h1>
                 <p>Make any math or science related app and earn a grant for anything math/science/programming
                  related or other special rewards.
                 </p>
                 <p style={{position: 'relative', display: 'inline-block'}}>
                   <span 
                     style={{borderBottom: '2px dotted #888', cursor: 'help', fontSize: '1.3rem'}}
                     onMouseEnter={(e) => {
                     const tooltip = e.currentTarget.nextSibling;
                     tooltip.timeoutId = setTimeout(() => {
                     tooltip.style.display = 'block';
                     tooltip.classList.add('tooltip-fade');
                     }, 100);
                     }}
                     onMouseLeave={(e) => {
                     const tooltip = e.currentTarget.nextSibling;
                     if (tooltip.timeoutId) clearTimeout(tooltip.timeoutId);
                       tooltip.style.display = 'none';
                        tooltip.classList.remove('tooltip-fade');
                      }}
                   >
                     Axiom V2 ended NYE
                   </span>
                 </p>
                 <h3><a href="https://hackatime.hackclub.com/" style={{color: 'lightblue'}}>Hackatime</a> time tracking is required.</h3>
                 <p style={{fontSize:"0.8rem"}}>Only for students aged 18 or under who are eligible for <a href="https://hackclub.com" style={{color:"lightblue"}}>Hack Club</a>.</p>
                 <p><Button href="https://submit.hackclub.com/axiom" className="rainbow-glow-row" style={{width: '100%', display: 'block', textAlign: 'center', marginBottom: '10px'}}>Submit</Button></p>
                 <p><Button href="/rewards">Rewards</Button> <Button href="https://hackclub.slack.com/archives/C09K4HZJ2DP">Join Slack</Button></p>
                 <p><Button href="/guides">Guides and tools</Button> <Button href="/faq">FAQ</Button></p>
                 <p><Button href="https://bananahannah7.github.io/drone_notebook/">Example project (not by me) </Button></p>
                 </div>
              </div>
            </div>
          </ColoredRoundedSquare>
        </Thingy>
        <ThingyEach script={"16x,h,1;9x,v,1"} z={0} dividerStyles={{border: '3px solid black'}}>
          <ColorOnHover></ColorOnHover>
        </ThingyEach>
      </LayerContainer>
            <span className="Mobile">
        <img src={logo} alt="Axiom Logo" width="400" class="MLAuto" />
        <br/>
        <div>
        {/* c75d53ff-5b68-455e-ab8d-abc94dda6548 */}
        <h1>Make a math/science related app,<br/> get rewards!</h1>
        <p>Make any math or science related app and earn a grant for anything math/science/programming
        related or other special rewards.
        </p>
        <p style={{position: 'relative', display: 'inline-block'}}>
          <span 
            style={{borderBottom: '2px dotted #888', cursor: 'help', fontSize: '1.3rem'}}
            onMouseEnter={(e) => {
              const tooltip = e.currentTarget.nextSibling;
              tooltip.timeoutId = setTimeout(() => {
                tooltip.style.display = 'block';
                tooltip.classList.add('tooltip-fade');
              }, 100);
            }}
            onMouseLeave={(e) => {
              const tooltip = e.currentTarget.nextSibling;
              if (tooltip.timeoutId) clearTimeout(tooltip.timeoutId);
              tooltip.style.display = 'none';
              tooltip.classList.remove('tooltip-fade');
            }}
          >
            V1 running from 11/4/25 to 11/18/25
          </span>
          <span style={{display: 'none', position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#222', color: '#fff', padding: '10px 14px', borderRadius: '6px', width: 'max-content', maxWidth: '380px', marginBottom: '8px', zIndex: 1000, fontSize: '1.05rem', boxShadow: '0 2px 8px rgba(0,0,0,0.3)', textAlign: 'center'}}>
            Axiom WILL have a V2! If you start a project for V1 but don't submit it, you WILL be able to submit for V2 and keep your tracked hours!
          </span>
        </p>
        <p><a href="https://hackatime.hackclub.com/" style={{color: 'lightblue'}}>Hackatime</a> time tracking is required.</p>
        <p style={{fontSize:"0.8rem"}}>Only for students aged 18 or under who are eligible for <a href="https://hackclub.com" style={{color:"lightblue"}}>Hack Club</a>.</p>
        <p><Button href="https://submit.hackclub.com/axiom" className="rainbow-glow-row" style={{width: '100%', display: 'block', textAlign: 'center', marginBottom: '10px'}}>Submit</Button></p>
        <p><Button href="/rewards">Rewards</Button> <Button href="https://hackclub.slack.com/archives/C09K4HZJ2DP">Join Slack</Button></p>
        <p><Button href="/guides">Guides and tools</Button> <Button href="/faq">FAQ</Button></p>
        <p><Button href="https://bananahannah7.github.io/drone_notebook/">Example project (not by me) </Button></p>
        </div>
      </span>
    </PageDiv>
    <PageTemplate path="submit">
      <h1>Submitting</h1>
      <p>The YSWS has started!</p>
      <p>If you are not in Hack Club yet, go to identity.hackclub.com and verify yourself first.</p>
      <p>You need to track your hours using Hackatime. <Button href="https://hackatime.hackclub.com/my/wakatime_setup">Set up Hackatime</Button></p>
      <p>Then, make your project while tracking the hours using Hackatime. After that, you can submit here:</p>
      <p><Button href="https://submit.hackclub.com/axiom" className="rainbow-glow-row" style={{width: '100%', display: 'block', textAlign: 'center', marginBottom: '10px'}}>Submit</Button></p>
      <p> or paste this link: https://submit.hackclub.com/axiom into your browser.</p>
      <p>Join the Slack channel #axiom as well  for any help or questions: <Button href="https://hackclub.slack.com/archives/C09K4HZJ2DP">Join Slack</Button></p>
    </PageTemplate>
    <PageDiv path="404" className="App">
    <h1>404 - Page Not Found</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
    <p><Button href="/">Go to Home</Button></p>
    </PageDiv> 
    <PageTemplate path="guides">
      <h2>Guides and Tools</h2>
      <p>Here are some guides and tools to help you get started with making math/science related apps.</p>
      
      <h3>MathQuill</h3>
      <p>This is a library for displaying LaTeX math in web applications.</p>
      
      <p><strong>Resources:</strong><Button href="/guides/mathquill">MathQuill template</Button> <Button href="https://docs.mathquill.com/en/latest/Getting_Started/">Official MathQuill docs (more advanced)</Button></p>

    <h3>LaTeX</h3>
    <p>This is the way you write math (and any kind of scientific document/research paper). If you don't know how to use this, you should check out the guide.</p>
    <p><strong>Resources:</strong> 
    <Button href="/guides/latex"> Easy LaTeX guide for math</Button>
    <Button href="https://www.overleaf.com/">Overleaf (the thing you use to edit LaTeX)</Button>
    <Button href="https://www.overleaf.com/learn/latex/Learn_LaTeX_in_30_minutes">Overleaf's LaTeX guide</Button>
    <Button href="https://www.latex-project.org/help/documentation/">Official LaTeX docs (only if you are desperate)</Button>
    </p>

      <h3>SymPy</h3>
      <p>This is an easy purepython CAS library. You may want to consider something else if you need more speed, but this is the easiest.</p>
      <p>Example code</p>
      <pre className="language-python"><code>{`from sympy import symbols, expand, factor, simplify,solve
x, y = symbols('x y')
expr1 = (x + 1)**2
expr2 = x**2 - 1
expanded = expand(expr1)
print(f"Expanded: {expanded}") // Expanded: x**2 + 2*x + 1
factored = factor(expr2)
print(f"Factored: {factored}") // Factored: (x - 1)*(x + 1)
simplified = simplify((x**2 - 1)/(x - 1))
print(f"Simplified: {simplified}") // Simplified: x + 1
solution = solve(x**2 - 4,x)
print(f"Solutions: {solution}") // Solutions: [-2, 2]`}
      </code></pre>
      <p><strong>Resources:</strong> <Button href="https://docs.sympy.org/latest/index.html">Official SymPy docs</Button></p>
      </PageTemplate>
      <PageTemplate path="guides-mathquill">
        <a href="/guides" style={{ color: '#64b5f6', textDecoration: 'underline', fontSize: "0.8rem" }}>Return to guides</a>
        <h1>MathQuill guide</h1>
        <p>This is a simple template to get you started with MathQuill.</p>
        <p>This is assuming static HTML/CSS/JS and knowledge of LaTeX. If you don't know LaTeX, check our guide: <Button href="/guides/latex">LaTeX guide</Button></p>
        <p>Include MathQuill CSS and JS in your HTML file. You can use the CDN links</p>
        <pre className="language-html"><code>{`
    <!-- in <head> -->
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js"></script>
 
    <script src="https://cdnjs.cloudflare.com/ajax/libs/mathquill/0.9.1/mathquill.js" integrity="sha512-ZSR/8q1yqynaTt93e8u/PNh6BsHRI/PWgriT6xObJIt+aFlOlOHFvQUJXB/SdHdI0HoEsi1asZejMPQOQhfRsg==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mathquill/0.9.1/mathquill.css" integrity="sha512-Gh9jugVbw863/UnmBitmARROcOkrLhMqPqbMEqwB5nfLf6g/bDEWgvPmwTav9e/s5LOwsnRhjtPSq/3yQ0RDsg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
       <script>
        MQ = MathQuill.getInterface(2);
    </script>
        `}</code></pre>
        <p>Now, create static or editable math fields anywhere</p>
        <pre className="language-html"><code>{`
<!-- static math field -->
<p>Solve <span id="problem">ax^2 + bx + c = 0</span>.</p>
<script>
  var problemSpan = document.getElementById('problem');
  MQ.StaticMath(problemSpan);
</script>
<!-- editable math field -->
<p><span id="answer">x=</span></p>
<script>
  var answerSpan = document.getElementById('answer');
  function checkAnswer(enteredMath) {
    if (enteredMath === '\\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}') {
      alert('Correct!');
    }
  }
  var answerMathField = MQ.MathField(answerSpan, {
    handlers: {
      edit: function() {
        var enteredMath = answerMathField.latex(); // Get entered math in LaTeX format
        checkAnswer(enteredMath);
      }
    }
  });
</script>
        `}</code></pre>
        <p>
        <h2>Template</h2>  
        <p>If you don't want to include something new in your script tag every time you want to make a math field, or just want something simpler, you can use this.</p>
        <p>Include MathQuill in your <code>{`<head>`}</code> tag as in the previous section, then paste this at the end of your body tag:</p>
        <pre>
          <code>
            {`
<script>
document.addEventListener('DOMContentLoaded', function() {
  var statics = document.querySelectorAll('.MQStatic');
  statics.forEach(function(i) { MQ.StaticMath(i); });

  var editables = document.querySelectorAll('.MathField');
  editables.forEach(function(i) {
    var answerMathField = MQ.MathField(i, {
      handlers: {
        edit: function() {
          var enteredMath = answerMathField.latex();
          var cb = i.dataset.callback;
          if (cb && typeof window[cb] === 'function') {
            window[cb](enteredMath);
          }
        }
      }
    });
  });
});
</script>
`}
          </code>
        </pre>
        <p>Use as follows:</p>
        <ul>
          <li>To make a static math field, simply make a <code>span</code> or <code>div</code> with the class <span><code>MQStatic</code></span>.</li>
          <li>Making an editable field is also easy. Use the <code>MathField</code> class instead and set the <code>data-callback</code> to the name of the function you want to call (with the latex as the input).<br></br>
          The function has to be global. To make it globa;, do something like <code>window.functionName = functionName</code></li>
        </ul>
        <p>Example: <Button href="/mq_example.html">Example (interactive)</Button> <Button href="/mq_example.txt">Example (code)</Button></p>

        
        <strong>Important:</strong></p>
        <ul>
          <li>Make sure to include jQuery before MathQuill.</li>
          <li>Use the correct MathQuill version.</li>
        </ul>
        
      </PageTemplate>
      <PageTemplate path="guides-latex">
        &nbsp;<a href="/guides" style={{ color: '#64b5f6', textDecoration: 'underline', fontSize: "0.8rem" }}>Return to guides</a>
        <h1>LaTeX</h1>
        <p>First, visit our MathQuill example (you don't need to look at the code now): <Button href="/mq_example.html">Visit it!</Button></p>
        <p>You should see an editable field:</p>
        <img src="/latex_editable.png" alt="LaTeX editable field example" width="300" />
        <p>Try typing math like normal, using expressions like  fractions, powers, parentheses, operators, functions (sin,cos) etc. You should see the output change.</p>
        <p>Doing this, you can already get a feel of how LaTeX works.</p>
        <ul>
          <li>Curly braces and backslashes work a bit like HTML.</li>
          <li>Fractions are denoted using the <code>{`\\frac{}{}`}</code> operator, where the first argument is the numerator and the second is the denominator.</li>
          <li>Exponents are denoted using <code>{`^`}</code> like normal, but sometimes curly braces have to be used for the base and exponent.</li>
          <li>Parentheses need to be indicated like so: <code>{`\\left(`}</code> and <code>{`\\right)`}</code>.</li>
          <li>The same actually applies to all brackets. So <code>{`\\left( \\left[ \\left\\{`}</code> all work. Note that the curly brace had to be escaped.</li>
        </ul>
        <p>But there are more things available in LaTeX than these in a complete document. Open up Overleaf, the LaTeX document editor.<Button href="https://overleaf.com">Open Overleaf</Button></p>
        <p>Login and create a blank project. It should look like this:</p>
        <img src="/overleaf_blank.png" alt="Overleaf blank project" width="600" />
        <p>You will notice there are some things prefilled in. This is because you are now editing a full document, not just a single expression.</p>
        <p>The <code>{`\\begin{document}`}</code> and <code>{`\\end{document}`}</code> indicate where the document starts and ends. </p>
        <p>You can use the visual editor here to test more advanced features of latex.</p>
        <ul>
          <li>Bold text: <code>{`\\textbf{...}`}</code></li>
          <li>Italics: <code>{`\\emph{...}`}</code></li>
          <li>Inline math: <code>{`$ ... $`}</code> — e.g. <code>{`$e^{i\\pi} + 1 = 0$`}</code></li>
          <li>Display math: <code>{`\\[ ... \\]`}</code> or <code>{`$$ ... $$`}</code> for larger centered equations</li>
        </ul>
        
        
      </PageTemplate>
      <PageTemplate path="rewards">
        <h1>Rewards</h1>
        <h2>Choose Your Reward</h2>
        <p>Code hours to earn rewards! Any remaining hours beyond your chosen reward go toward grants or additional items.</p>
        <p>If you want any other rewards, tell us in slack in <a href="https://hackclub.slack.com/archives/C09K4HZJ2DP" style={{color: 'lightblue'}}>#axiom</a>.</p>
        <p style={{borderLeft: '4px solid #888', paddingLeft: '16px', marginBottom: '20px'}}>
          <strong>International Participants:</strong> Listed prices are for US and Canada only. If you're located elsewhere, you can still claim physical prizes! Find a seller in your region (click "View details" on any product and check available sellers), and we'll calculate a new hour requirement at <strong>$4.50 USD/hour</strong> including shipping costs.
        </p>
        <h3>Raspberry Pi ± Kits</h3>
        <table style={{borderCollapse: 'collapse', width: '100%', marginBottom: '20px', border: '1px solid #ddd'}}>
          <thead>
            <tr style={{backgroundColor: '#111111'}}>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Product</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Hours Required</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Notes</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Model Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-zero-2-w.html?cid=usd" style={{color: 'lightblue'}}>Base Pi Zero 2W</a> (512MB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>7+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-zero-2-w/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-zero-2-w.html?cid=usd" style={{color: 'lightblue'}}>Pi Zero 2W Kit</a> (512MB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>10+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-zero-2-w/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-4-2gb.html?cid=usd" style={{color: 'lightblue'}}>Base Pi 4B</a> (2GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>14+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-4-model-b/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-4-starter-kit.html?cid=usd" style={{color: 'lightblue'}}>Pi 4B Kit</a> (2GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>26+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Complete kit included</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-4-model-b/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-4-starter-kit.html?cid=usd" style={{color: 'lightblue'}}>Pi 4B Kit</a> (2GB RAM) + <a href="https://www.canakit.com/raspberry-pi-camera-module-3.html?cid=usd" style={{color: 'lightblue'}}>Pi Camera</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>35+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-4-model-b/" style={{color: 'lightblue'}}>View details</a> (<a href="https://www.raspberrypi.com/products/camera-module-3/" style={{color: 'lightblue'}}>View camera details</a>)</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-5-4gb.html?cid=usd" style={{color: 'lightblue'}}>Base Pi 5</a> (4GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>16+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Latest generation</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-5/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-5-4gb.html?cid=usd" style={{color: 'lightblue'}}>Pi 5 Kit</a> (4GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>30+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Latest generation</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-5/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-5-4gb.html?cid=usd" style={{color: 'lightblue'}}>Pi 5 Kit</a> (4GB RAM) + <a href="https://www.canakit.com/raspberry-pi-camera-module-3.html?cid=usd" style={{color: 'lightblue'}}>Pi Camera</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>36+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-5/" style={{color: 'lightblue'}}>View details</a> (<a href="https://www.raspberrypi.com/products/camera-module-3/" style={{color: 'lightblue'}}>View camera details</a>)</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-5-8gb.html?cid=usd" style={{color: 'lightblue'}}>Base Pi 5</a> (8GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>20+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>No kit</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-5/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-5-16gb.html?cid=usd" style={{color: 'lightblue'}}>Base Pi 5</a> (16GB RAM)</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>28+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>no kit, what are you even running here?</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-5/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-500.html?cid=usd" style={{color: 'lightblue'}}>Pi 500 Basic</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>24+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>No mouse, HDMI cable, or power supply</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-500/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-500-desktop-kit.html?cid=usd" style={{color: 'lightblue'}}>Pi 500 Desktop Kit</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>30+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Includes mouse, HDMI cable, 27W USB-C power supply, guidebook</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-500/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-500-plus.html?cid=usd" style={{color: 'lightblue'}}>Pi 500 Plus</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>44+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Uses RPI 5 16GB RAM, 256GB NVMe, RGB keyboard</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-500/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.canakit.com/raspberry-pi-500-plus.html?cid=usd" style={{color: 'lightblue'}}>Pi 500 Plus Desktop Kit</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>48+ hours</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Uses RPI 5 16GB RAM, 256GB NVMe, RGB keyboard</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.raspberrypi.com/products/raspberry-pi-500/" style={{color: 'lightblue'}}>View details</a></td>
            </tr>
          </tbody>
        </table>

        <h3>Bonus</h3>
        <table style={{borderCollapse: 'collapse', width: '100%', marginBottom: '20px', border: '1px solid #ddd'}}>
          <thead>
            <tr style={{backgroundColor: '#111111'}}>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Product</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Hours Required</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.casio.com/us/scientific-calculators/product.FX-991CW/" style={{color: 'lightblue'}}>Casio FX-991CW</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>7+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://store.arduino.cc/products/uno" style={{color: 'lightblue'}}>Arduino UNO R4</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>12+ hours</td>
            </tr>
            <tr className="rainbow-glow-row">
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.crunchlabs.com/" style={{color: 'lightblue'}}>CrunchLabs 2 Month Subscription</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>19+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.casio.com/us/scientific-calculators/product.FX-CG50/" style={{color: 'lightblue'}}>Casio FX-CG50 Graphing Calculator</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>24+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://education.ti.com/en/products/calculators/graphing-calculators/ti-84-plus-ce-python" style={{color: 'lightblue'}}>TI-84 Plus CE Python Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>24+ hours</td>
            </tr>
            <tr className="rainbow-glow-row">
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.curiositybox.com/" style={{color: 'lightblue'}}>Curiosity Box</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>25+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://education.ti.com/en/products/calculators/graphing-calculators/ti-nspire-cx-ii-cx-ii-cas" style={{color: 'lightblue'}}>TI-Nspire CX II</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>31+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://developer.nvidia.com/embedded/jetson-nano" style={{color: 'lightblue'}}>NVIDIA Jetson Nano</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>30+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://store.potensic.com/products/atom-lt" style={{color: 'lightblue'}}>ATOM LT Sub-250g GPS Camera Drone</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>38+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://bambulab.com/en-us/a1-mini" style={{color: 'lightblue'}}>Bambu Lab A1 Mini 3D Printer</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>45+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.nvidia.com/en-us/autonomous-machines/embedded-systems/jetson-orin/nano-super-developer-kit/" style={{color: 'lightblue'}}>NVIDIA Jetson Orin Nano Super Developer Kit</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>50+ hours</td>
            </tr>
            <tr className="rainbow-glow-row">
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.crunchlabs.com/" style={{color: 'lightblue'}}>CrunchLabs 6 Month Subscription</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>52+ hours</td>
            </tr>
            <tr className="rainbow-glow-row">
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.crunchlabs.com/" style={{color: 'lightblue'}}>CrunchLabs 12 Month Subscription</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>84+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Grant for Math books</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>$5/hour</td>
            </tr>
            <tr className="rainbow-glow-row">
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Grant for Leetcode, Coursera AoPS etc.</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>$5/hour</td>
            </tr>
          </tbody>
        </table>

        <h3>Math Software</h3>
        <table style={{borderCollapse: 'collapse', width: '100%', marginBottom: '20px', border: '1px solid #ddd'}}>
          <thead>
            <tr style={{backgroundColor: '#111111'}}>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Software</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Duration</th>
              <th style={{border: '1px solid #ddd', padding: '12px', textAlign: 'left'}}>Hours Required</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.maplesoft.com/products/Maple/" style={{color: 'lightblue'}}>Maple Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 year</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>15+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.mathworks.com/products/matlab.html" style={{color: 'lightblue'}}>MATLAB Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>Forever</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>10+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolframalpha.com/pro/" style={{color: 'lightblue'}}>Wolfram Alpha Pro</a> or <a href="https://www.wolframalpha.com/pro-for-students/" style={{color: 'lightblue'}}>Wolfram Alpha Pro for Students</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 month</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>2+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolframalpha.com/pro/" style={{color: 'lightblue'}}>Wolfram Alpha Pro</a> or <a href="https://www.wolframalpha.com/pro-for-students/" style={{color: 'lightblue'}}>Wolfram Alpha Pro for Students</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>6 months</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>7+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolframalpha.com/pro/" style={{color: 'lightblue'}}>Wolfram Alpha Pro</a> or <a href="https://www.wolframalpha.com/pro-for-students/" style={{color: 'lightblue'}}>Wolfram Alpha Pro for Students</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 year</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>12+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.solidworks.com/product/students" style={{color: 'lightblue'}}>SolidWorks Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 year</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>12+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolfram.com/mathematica-student-edition/" style={{color: 'lightblue'}}>Mathematica Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 month</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>2+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolfram.com/mathematica-student-edition/" style={{color: 'lightblue'}}>Mathematica Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>6 months</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>10+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolfram.com/mathematica-student-edition/" style={{color: 'lightblue'}}>Mathematica Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>1 year</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>15+ hours</td>
            </tr>
            <tr>
              <td style={{border: '1px solid #ddd', padding: '12px'}}><a href="https://www.wolfram.com/mathematica-student-edition/" style={{color: 'lightblue'}}>Mathematica Student Edition</a></td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>4 years</td>
              <td style={{border: '1px solid #ddd', padding: '12px'}}>39+ hours</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Note:</strong> Any remaining hours beyond your chosen reward can be applied toward grants for math/science related items at $4/h or additional items from the same or a different category.</p>
        
      </PageTemplate>
    <PageTemplate path="faq">
      <h1>FAQ</h1>
      <h3>Who can join?</h3>
      <p>A: Anyone who is 18 or under and eligible for Hack Club can join. If you're not in Hack Club yet, you can sign up at identity.hackclub.com.</p>
      <h3>What kind of apps can I make?</h3>
      <p>A: Any app related to math or science! It can be a calculator, a graphing tool, a physics simulator, or anything else you can think of.</p>
      <p>   However, programming itself does not count as math/science related.</p>
      <p>   If you are making a calculator, it has to be better than typing <code>python</code> in the terminal or using a Jupyter notebook.</p>
      <p>   <strong>The main purpose does not necessarily have to be math or science related</strong>, but if so it has to use (preferrably complicated) math inside the program.</p>
      <h3>Do I need to download anything?</h3>
      <p>A: Not really, but you do need to set up Hackatime. <Button href="https://hackatime.hackclub.com/my/wakatime_setup">Setup</Button></p>
      <p>You can use Codespaces if you want.</p>
      <h3>How many projects can I make?</h3>
      <p>A: As many as you want! Minimum time spent on each project must be 8hrs.</p>
      <h3>Are the hours spent on V1, V2 and time between counted?</h3>
      <p>A: Yes. All of it. If you have'nt submitted already.</p>
      <h3>Does the project have to be finished to submit?</h3>
      <p>A: Yes T-T</p>
      <h3>Can I build upon older projects?</h3>
      <p>A: Yes, as long as you add meaningful features to it and fullfil the minimum hour requirement. 
            However, only new hours logged on those projects will be counted</p>
      <h3>Can I fork projects and build upon them?</h3>
      <p>A: Yes, as long as you add meaningful features to it and fullfil the minimum hour requirement. 
            However, only new hours logged on those projects will be counted</p>
      <h3>Can my project be a bunch of small ones under one website/ app?</h3>
      <p>A: No.</p>
      <h3>Would this be a good project idea?</h3>
      <p>A: Ask <a href="https://hackclub.enterprise.slack.com/docs/T0266FRGM/F09Q2U6AWH1" style={{color: "lightblue"}}>here</a></p>
      <h3>Is AI allowed?</h3>
      <p>No.</p>
      <h3>I want the rewards list to be extended!</h3>
      <p>A: Ask in <a href="https://hackclub.enterprise.slack.com/docs/T0266FRGM/F09JVLBN9RD" style={{color: "lightblue"}}>this</a> canvas on slack, the rate for items approved here will be $4/h</p>
      <h3>How can I avoid hour reduction after I submit?</h3>
      <p>A: Frequent and descriptive commits every 1hr or so.</p>
      <p>   Your hours may get reduced if the time you spent on the project is much bigger than the time it would be expected to take</p>
      <h3>What are the submission requirements?</h3>
      <p>A: A github URL with frequent commits, and a live demo/ playable link of the project</p>
      <h3>What if I find a cheaper vendor for my country?</h3>
      <p>A: DM the link to the vendor and product to @dhamari on slack and you can work less hours!</p>
      <h3>What do I do after submission?</h3>
      <p>A: We'll review your project, and dm you your HCB grant!</p>
      <h3>What if I have issues with HCB?</h3>
      <p>A: You'll have to ask in #hcb</p>
      <h3>Is the grant stackable?</h3>
      <p>A: Yes.</p>
      <h3>Who is handling fullfilment?</h3>
      <p>A: @dhamari on slack</p>
      <h3>Can I double dip?</h3>
      <p>A: Not with Accelerate or Athena, but you will have to ask the respective hosts if you want to double dip with something else</p>
      <h3>I have more questions!</h3>
      <p>Ask in the Slack channel #axiom</p>

    </PageTemplate>
    </>
  );
}

export default App;
